export default class {
    constructor (lodash, LearndashResource, TokenService, ModalService, SiteService, ROLE_PRIVILEGE_ENUM) {
        this.lodash = lodash;
        this.LearndashResource = LearndashResource;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.SiteService = SiteService;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
    }

    $onInit () {
        this.showLearndashCourseEditLink = false;
        this.learndashCourses = [];
    }

    setLdCourses (learndashCourses) {
        this.learndashCourses = learndashCourses;
    }

    getLearndashCourse (training) {
        training.canEditLearndashCourse = false;
        if (training.learndashCourseId) {
            this.LearndashResource.getCourse({
                id: training.learndashCourseId,
                _lang: this.TokenService.getCompanyLanguage(true)
            }).$promise.then(result => {
                training.canEditLearndashCourse = result.isEditable;
                this.showLearndashCourseEditLink = result.isEditable;
            });
        }
    }

    addLdMaterial (training) {
        const latestLearndashCourse = this.getLastInsertedLDCourse(this.learndashCourses);
        return this.ModalService.open({
            template: `
                <modals-courses-version-training-ld-material
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
            },
            size: 'xlarge'
        }).catch(() => {
            const params = {
                lang: this.TokenService.getCompanyLanguage(true)
            };

            this.LearndashResource.getCompanyCourses(params).$promise.then((learndashCoursesResponse) => {
                const newLatestLearndashCourse = this.getLastInsertedLDCourse(learndashCoursesResponse);
                this.setLdCourses(learndashCoursesResponse);
                if (latestLearndashCourse.ID !== newLatestLearndashCourse.ID) {
                    training.learndashCourseId = newLatestLearndashCourse.ID;
                }
            });
        });
    }

    editLdMaterial (training) {
        return this.ModalService.open({
            template: `
                <modals-courses-version-training-ld-material
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    post-id="vm.training.learndashCourseId"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.training = training;
            },
            size: 'xlarge'
        });
    }

    getLastInsertedLDCourse (learndashCourses) {
        const currentUserId = this.TokenService.getLdUserId();
        const currentUserLdCourses = this.lodash.filter(learndashCourses, course => parseInt(course.post_author, 10) === currentUserId);
        return this.lodash.maxBy(currentUserLdCourses, o => o.ID);
    }

    getPreviewLink (id) {
        const token = this.TokenService.token.replace('Bearer ', '');
        const learndashCourse = this.lodash.find(this.learndashCourses, { ID: id });
        if (!learndashCourse) {
            return '';
        }
        const sep = learndashCourse.guid.indexOf('?') === -1 ? '?' : '&';
        return `${learndashCourse.guid}${sep}jwt=${token}&redirect=0`;
    }

    hasAccessToLdStudyMaterials (currentId) {
        if (!currentId) {
            return true;
        }

        return !!this.lodash.find(this.learndashCourses, (course) => parseInt(course.ID, 10) === parseInt(currentId, 10));
    }

    hasManageMaterialsPrivilegeSite () {
        return this.SiteService.getSitesByPrivileges([this.ROLE_PRIVILEGE_ENUM.KEYS.MATERIALS_MANAGE]).length;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/version/trainingForm/learndash/index.js